module.exports = __webpack_public_path__ + "static/01-6afc794050fdf8469f0c4db1bd5ada7c.jpg";